enum AiContentProjectAgentToolName {
  CreateItems = 'create-items',
  UpdateItems = 'update-items',
  GeneratePrompts = 'generate-prompts',
  GenerateAssets = 'generate-assets',
  UpdateBrief = 'update-brief',
  UpdateInputParameters = 'update-input-parameters',
}

export {AiContentProjectAgentToolName};
